import { render, staticRenderFns } from "./relevance.code-review.vue?vue&type=template&id=bc14d790&scoped=true&"
import script from "./relevance.code-review.vue?vue&type=script&lang=js&"
export * from "./relevance.code-review.vue?vue&type=script&lang=js&"
import style0 from "./relevance.code-review.vue?vue&type=style&index=0&id=bc14d790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc14d790",
  null
  
)

export default component.exports